import { onChangeCreator, updateWithDailyDaysInterval, updateWithDailyOption } from 'app/area/company-report/components/schedule-helpers';
import { RecurringDailyOptions, ScheduleFieldKeys } from 'app/area/company-report/constants';
import * as React from 'react';
import { Numberbox } from 'ui';
import { SelectSingleRadioButton } from 'ui/select-single-short-list/select-single-radio-button/select-single-radio-button';
import styles from './report-screen.scss';

export const DailySchedule = ({
  setScheduleDefinition,
  scheduleDefinition,
  translations,
  locale,
  getValidationErrors
}) => {

  const { option, daysInterval } = scheduleDefinition?.recurDaily;
  const selectedDailyPatternOptionValue = option?.value;
  const onChangeDailyDaysInterval = onChangeCreator(
    updateWithDailyDaysInterval, setScheduleDefinition);
  const onChangeDailyPatternOption = onChangeCreator(
      updateWithDailyOption, setScheduleDefinition);

  const isSelected = (value: number): boolean => selectedDailyPatternOptionValue === value;  
  
  const daysIntervalValidation = isSelected(RecurringDailyOptions.EveryDay)
    && getValidationErrors(ScheduleFieldKeys.recurDailyDaysInterval);
  
  return <div>
  <div className={`${styles.scheduleRow}`}>
    <div className={styles.textWrapper}>
      <SelectSingleRadioButton
        componentId={`${ScheduleFieldKeys.recurDailyOption}-${RecurringDailyOptions.EveryDay}`}
        onChange={onChangeDailyPatternOption}
        isSelected={isSelected(RecurringDailyOptions.EveryDay)}
        option={{ value: RecurringDailyOptions.EveryDay, description: translations.every }}
        validation={getValidationErrors(ScheduleFieldKeys.recurDailyOption)}
      />
    </div>
    <div className={styles.numberbox}>
      <Numberbox
        componentId={ScheduleFieldKeys.recurDailyDaysInterval}
        value={daysInterval}
        onChange={onChangeDailyDaysInterval}
        className={styles.scheduleNumberbox}
        readOnly={!isSelected(RecurringDailyOptions.EveryDay)}
        validation={daysIntervalValidation}
        locale={locale}
        maxValue={999999999}
      />
    </div>
    <div className={styles.textWrapper}>
      <span className={styles.texts}>{translations.days}</span>
    </div>
  </div>
  <div className={`row ${styles.scheduleRow}`}>
    <div>
      <SelectSingleRadioButton
        componentId={`${ScheduleFieldKeys.recurDailyOption}-${RecurringDailyOptions.EveryWeekday}`}
        onChange={onChangeDailyPatternOption}
        isSelected={isSelected(RecurringDailyOptions.EveryWeekday)}
        option={{ value: RecurringDailyOptions.EveryWeekday, description: translations.every_weekday }}
        validation={getValidationErrors(ScheduleFieldKeys.recurDailyOption)}
      />
    </div>
  </div>
</div>;
};
